// Argus — MiddleEllipsis: trunchiere text cu „…" în mijloc, păstrând extensia + prefix.
// Pentru filename "long_document_name_2026.pdf" pe lățime mică → "long_doc…2026.pdf".
// Implementare CSS-only via flex + min-width 0 + 2 spans cu direction rtl pe a doua jumătate.

import { Box } from '@mui/material';

export interface MiddleEllipsisProps {
  text: string;
  /** Câte caractere finale păstrăm vizibile (default 6 — typical extension + few chars). */
  tail?: number;
  fontSize?: number;
}

export function MiddleEllipsis({ text, tail = 6, fontSize }: MiddleEllipsisProps): JSX.Element {
  if (text.length <= tail + 4) {
    return <span style={fontSize ? { fontSize } : undefined}>{text}</span>;
  }
  const head = text.slice(0, text.length - tail);
  const tailText = text.slice(text.length - tail);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minWidth: 0,
        width: '100%',
        whiteSpace: 'nowrap',
        ...(fontSize ? { fontSize } : {}),
      }}
      title={text}
    >
      <Box
        sx={{
          flex: '0 1 auto',
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {head}
      </Box>
      <Box sx={{ flex: '0 0 auto', whiteSpace: 'nowrap' }}>{tailText}</Box>
    </Box>
  );
}
